import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ChatbotServiceVirtual,
  ChatbotServiceCustom,
  ChatbotServiceNatural,
  ChatbotServiceSoftware,
} from "../../../app-constants";

function Chatbotservices() {
  return (
    <section
      className="chatbot_services p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              AI Chatbot Development Services: Agile Chatbots for Seamless
              Integration
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              The chatbots we create are known for their accuracy in responding
              to customer queries. Our custom chatbot development services cater
              clients with a variety of needs. Our chatbots won’t bore your
              customers with long, vague responses. Instead, they’re specially
              designed to churn out precise answers keeping client
              correspondence smooth, and effective.
            </p>
            <p>
              Here’s what we offer to help your business benefit from agile
              chatbot adaptation:
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="chatbot_services_box">
                  <div className="chatbot_serv_main">
                    <div className="chatbot_serv_num">
                      <h2>01</h2>
                    </div>
                    <div className="chatbot_serv_flex">
                      <div className="chatbot_serv_icon">
                        {ChatbotServiceVirtual}
                      </div>
                      <div className="chatbot_serv_head">
                        <h5>Virtual Assistant Design</h5>
                      </div>
                    </div>
                  </div>
                  <p>
                    Our chatbot development solutions are industry specific. We
                    offer intelligent designs for your unique domains. So, all
                    our virtual assistant designs are highly customizable.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="chatbot_services_box">
                  <div className="chatbot_serv_main">
                    <div className="chatbot_serv_num">
                      <h2>02</h2>
                    </div>
                    <div className="chatbot_serv_flex">
                      <div className="chatbot_serv_icon">
                        {ChatbotServiceCustom}
                      </div>
                      <div className="chatbot_serv_head">
                        <h5>Custom Chatbot Development Services</h5>
                      </div>
                    </div>
                  </div>
                  <p>
                    Custom bots are designed with the idea of helping businesses
                    enhance their customer experience. These bots analyze user
                    demographics, and psychographics to deliver satisfying
                    responses.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="chatbot_services_box">
                  <div className="chatbot_serv_main">
                    <div className="chatbot_serv_num">
                      <h2>03</h2>
                    </div>
                    <div className="chatbot_serv_flex">
                      <div className="chatbot_serv_icon">
                        {ChatbotServiceNatural}
                      </div>
                      <div className="chatbot_serv_head">
                        <h5>Natural Language Processing Solutions</h5>
                      </div>
                    </div>
                  </div>
                  <p>
                    Our chatbot development teams have experts who work on
                    Natural language processing (NLP). As a result, our chatbots
                    are keen to analyze human sentiment, and generate responses
                    that align with the needs of the user.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="chatbot_services_box">
                  <div className="chatbot_serv_main">
                    <div className="chatbot_serv_num">
                      <h2>04</h2>
                    </div>
                    <div className="chatbot_serv_flex">
                      <div className="chatbot_serv_icon">
                        {ChatbotServiceSoftware}
                      </div>
                      <div className="chatbot_serv_head">
                        <h5>Chatbot Software Development</h5>
                      </div>
                    </div>
                  </div>
                  <p>
                    Along with offering chatbot development consultancy, we also
                    have set APIs for AI chatbots. You can integrate these with
                    your platform or website at a glance, creating personalized
                    experiences for your customers.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Chatbotservices;
